var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportantIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C8.4243 0 7.93112 0.352504 7.72221 0.85462L0.208233 13.8764V13.8777C0.0726245 14.0972 0.000520725 14.3503 0 14.6087C0 14.9777 0.145879 15.3316 0.405544 15.5925C0.66521 15.8534 1.01739 16 1.38462 16C1.4171 15.9998 1.44958 15.9984 1.48197 15.9959L1.48468 16H9H16.5153L16.518 15.9946C16.5504 15.9975 16.5829 15.9993 16.6154 16C16.9826 16 17.3348 15.8534 17.5945 15.5925C17.8541 15.3316 18 14.9777 18 14.6087C17.9997 14.3499 17.9276 14.0963 17.7918 13.8764L17.781 13.8573L17.7796 13.856L10.2778 0.85462C10.0689 0.352504 9.5757 0 9 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83969 5.81543H8.16031L8.29958 10.3181H9.70042L9.83969 5.81543Z",
    fill: "#C8585F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91271 12.5274C9.91271 12.0022 9.57178 11.6945 9.0027 11.6945C8.42878 11.6945 8.08594 12.0022 8.08594 12.5274C8.08594 13.0429 8.42947 13.3494 9.0027 13.3494C9.57178 13.3494 9.91271 13.0429 9.91271 12.5274Z",
    fill: "#C8585F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantIcon);
export default __webpack_public_path__ + "static/media/important-icon.a6b701dccb0141f1fc4cce1eba1be2c1.svg";
export { ForwardRef as ReactComponent };